export default __webpack_public_path__ + "static/media/review.85d5b092.svg";